/**
 * 10.9BT — REGIÃO "dona" de cada monstro + identidade visual por região.
 * Derivado do config (tabela de spawn da região e gangues dos territórios), como o
 * EnemySpawner já fazia (10.9BM). Vive num util próprio pra o CreatureBuilder escolher
 * pele/tinta/borda pela região sem importar o spawner (evita ciclo).
 */
import { GameConfig } from "../config/GameConfig";
import type { SkinKind } from "./CreatureSkins";

export const ENEMY_REGION: Record<string, string> = (() => {
  const m: Record<string, string> = {};
  for (const r of GameConfig.world.regions) for (const e of r.enemyTable) m[e.id] ??= r.id;
  for (const t of GameConfig.territories.list) for (const g of t.gang) m[g.id] ??= t.regionId;
  return m;
})();

/** Região do monstro pelo id (fallback: Floresta). */
export function enemyRegion(id: string): string {
  return ENEMY_REGION[id] ?? "forgottenForest";
}

/** Acabamento visual por região: pele principal/secundária, tinta dos "veios" e cor da borda. */
export interface RegionLook {
  skin: SkinKind; // pele do corpo (material principal)
  skin2: SkinKind; // pele das placas/pedra (materiais secundários)
  tint: number; // tinta secundária (mistura no emissivo — veios/facetas/riscos)
  rim: number; // cor da luz de borda
}

const LOOKS: Record<string, RegionLook> = {
  // Floresta: couro/quitina com veios verde-musgo
  forgottenForest: { skin: "hide", skin2: "chitin", tint: 0x4f8a3a, rim: 0x8fe86a },
  // Terras Partidas: cristal/escamas com facetas ciano
  shatteredWilds: { skin: "crystal", skin2: "scales", tint: 0x2fb8c8, rim: 0x62e8ff },
  // Tempestade: pedra/escamas com riscos azul-elétrico
  tempestReach: { skin: "stone", skin2: "scales", tint: 0x3a6cff, rim: 0x6fb8ff },
};

export function regionLook(regionId: string): RegionLook {
  return LOOKS[regionId] ?? LOOKS.forgottenForest;
}
